import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ListBox } from '@progress/kendo-react-listbox';
import NoRecordsMessage from '../grid/no-records-message';
import { SearchBox } from '../search-box';

import './index.scss';

interface IProps<T> {
    textField: keyof T;
    data: T[];
}

const SearchableListBox = <T,>({ textField, data }: IProps<T>) => {
    const { t } = useTranslation();
    const [filter, setFilter] = useState<string>('');

    return (
        <div className="searchable-list-box">
            <SearchBox
                fillMode="flat"
                data-testid="search-item-input"
                showSearchIcon
                value={filter}
                onChange={(e) => setFilter((e.value as string) ?? '')}
                className="search-box"
            />
            {data.length === 0 ? (
                <NoRecordsMessage message={t('noDataToDisplay')} />
            ) : (
                <ListBox
                    className="list-box"
                    textField={textField as string}
                    data={data.filter((item) =>
                        (item[textField] as string).toLowerCase().includes(filter.toLowerCase()),
                    )}
                />
            )}
        </div>
    );
};

export default SearchableListBox;
